<template>

  <table
      class="table b-table b-table-stacked-xs table-bordered table-sm bg-white text-uppercase"
  >
    <tbody>
    <tr>
      <th colspan="4">
        <h5 class="text-center"><b>Programas Sociais</b></h5>
      </th>
    </tr>
    <tr>
      <td colspan="4">
        <load v-if="loadingProgramas"
              mode="table"/>
        <div v-else
             class="col-md-12">

          <b-table
              :fields="[
            {
                key: 'protocolo',
                label: $t('Detalhes'),
            },
            {
                key: 'cadastrado',
                label: $t('Data'),
            },
          ]"
              :items="ProgramasList"
              :responsive="true"
              hover
              outlined
              show-empty
              small
              stacked="xs"
              striped
              table-class="mb-3"
          >
            <template v-slot:cell(protocolo)="data">
              <span class="d-block">
              Programa: <b>{{ data.item.programa.nome }}</b></span>
              Beneficiário(s):<br/>
              <ul>
                <li
                    v-for="pessoa in data.item.pessoas_objetos"
                    :key="pessoa.id"
                >
                  <b
                  >{{ pessoa.nome_completo }}
                  </b>
                </li>
              </ul>
              Valor: <b>R$ {{ data.item.valor }}</b>

            </template>
            <template v-slot:cell(cadastrado)="data">
              {{ data.item.cadastrado }}
            </template>

            <template v-slot:empty="scope">
              <div class="text-center my-5">
                <img
                    :alt="$t('No results')"
                    class="mb-5"
                    src="/img/icons/robot.svg"
                    style="max-height: 165px"
                />
                <h3 class="bold">
                  {{ $t("No records found") }}
                </h3>
              </div>
            </template>
          </b-table>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "Programas",
  props: ['familia'],
  data() {
    return {
      ProgramasList: [],
      loadingProgramas: true,
    }
  },
  mounted() {
    this.getProgramas();
  },
  methods: {
    getProgramas() {
      this.loadingProgramas = true;
      axios
          .get(`api/dashboard/print/usuarios/programas/${this.familia}`)
          .then((response) => {
            this.ProgramasList = response.data.data;
            this.loadingProgramas = false;
          })
          .catch(() => {
            this.loadingProgramas = false;
          });
    },
  },
}
</script>

<style scoped>

</style>